import Domen from '../../../stores/Domen';
import GlobalState, {
    changeLoadSegmentation, 
    changesegmentationpage, 
    changeActivePortraits,
    changePortraitsheduledeploynameAll,
    changesegmentationpagecenter1 } from '../../../stores/GlobalState';


export async function GetDataPortrait() {
    changeLoadSegmentation(1);
    var height = window.innerHeight;
    var limit = Math.trunc((height*1-370)/35);
    const token = localStorage.getItem("token");
    localStorage.setItem("countactivetime", Date.now());

    try {
        const response = await fetch(`${Domen.url}portraits/table?page=${GlobalState.numpagesdatasetsportraits}&limit=${limit}`, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            },
        });

        if (response.status === 200) {
            const data = await response.json();

            if (data.state === 'in_progress') {
                setTimeout(() => {
                    GetDataPortrait(limit); // рекурсивно викликаємо, щоб перевірити знову через 10 сек
                }, 10000);
            } else if (data.state === 'failed') {
                changeLoadSegmentation(3);
                changesegmentationpage(1);
            } else if (data.state === 'finished') {
                if (data?.deploymentInfo?.[0]) {
                    const deploy = data.deploymentInfo[0];
                    // console.log(deploy.bigquery_table_name);

                    changesegmentationpagecenter1(4);

                    changePortraitsheduledeploynameAll(
                        deploy.bigquery_table_name,
                        deploy.periodicity,
                        deploy.start_time,
                        deploy.id,
                        deploy.last_changes
                    );
                }

                changeActivePortraits(data);
                changesegmentationpage(2);

                setTimeout(() => {
                    changeLoadSegmentation(3);
                }, 3000);
            }

            if(data.length === 0){
                changeLoadSegmentation(3);
                changesegmentationpage(1);
            }
        } else {
            changeLoadSegmentation(3);
            changesegmentationpage(1);
        }
    } catch (error) {
        console.error("Error fetching portrait data:", error);
        changeLoadSegmentation(3);
        changesegmentationpage(1);
    }
}
